module.exports = __webpack_public_path__ + "static/media/ico_phone_two.50ad859c.svg";